angular.module('autoremind.reports.communication')
    .directive('messagesOverview', ['$location', '$log', 'dialogs', 'logger', 'userProfile', 'messagesService', 'jobService', '$timeout', 'todoService', 'reportConfig', '$routeParams', '$filter',
    function ($location, $log, dialogs, logger, userProfile, messagesService, jobService, $timeout, todoService, reportConfig, $routeParams, $filter) {
        return {
            templateUrl: 'app/reports/communication/messages/messages-overview.html',
            restrict: 'E',
            scope: true,
            link: function ($scope, elem, attr) {
                $scope.viewModel.messagesSentStats = {
                    last7DaysEmailSent: 0,
                    last7DaysSmsSent: 0,
                    last7DaysTotalSent: 0,
                    last7DaysVoiceSent: 0,
                    last30DaysEmailSent: 0,
                    last30DaysSmsSent: 0,
                    last30DaysTotalSent: 0,
                    last30DaysVoiceSent: 0,
                    thisWeekEmailSent: 0,
                    thisWeekSmsSent: 0,
                    thisWeekTotalSent: 0,
                    thisWeekVoiceSent: 0,
                    todayEmailSent: 0,
                    todaySmsSent: 0,
                    todayTotalSent: 0,
                    todayVoiceSent: 0
                };
                // $scope.viewModel.loadingIndicator = false;
                $scope.init = function () {
                    $scope.viewModel.loadingIndicator = true;
                    var model = {
                        list: []
                    };
                    jobService.getJobs(model, $scope.messageReportType, $scope.jobId) // TODO: Remove jobId from url - it makes no sense for getting jobs here after getting stats from new endpoint
                        .then(function (data) {
                        jobService.getMessagesSentStats($scope.messageReportType, $scope.jobId)
                            .then(function (data) {
                            $scope.viewModel.loadingIndicator = false;
                            if (!angular.isDefined(data.messagesSentStats)) {
                                return;
                            }
                            // $scope.viewModel.messagesSentStats = Object.assign($scope.viewModel.messagesSentStats, data.messagesSentStats);
                            for (var i in data.messagesSentStats) {
                                if (data.messagesSentStats[i] && (!isNaN(data.messagesSentStats[i]) || isNaN(parseInt(data.messagesSentStats[i])))) {
                                    $scope.viewModel.messagesSentStats[i] = parseInt(data.messagesSentStats[i]);
                                }
                            }
                            $scope.updateChartData();
                        }, function () {
                            $scope.viewModel.loadingIndicator = false;
                        });
                    }, function () {
                        $scope.viewModel.loadingIndicator = false;
                    });
                }();
                $scope.perMediaDeliveryChart = {
                    type: "ColumnChart",
                    displayed: true,
                    cssStyle: "height:200px; width:100px; margin-bottom: 0px",
                    data: [
                        ['Label', ''],
                        ['Text', $scope.viewModel.messagesSentStats.last30DaysSmsSent],
                        ['Email', $scope.viewModel.messagesSentStats.last30DaysEmailSent],
                        ['Calls', $scope.viewModel.messagesSentStats.last30DaysVoiceSent]
                    ],
                    options: {
                        title: "Sent per media last 30 days",
                        height: 220,
                        width: 350,
                        isStacked: "true",
                        fill: 20,
                        legend: 'none',
                        displayExactValues: true,
                        colors: ['#3B80A4', '#4D9EC9', '#6EB3D4', '#92C6E0', '#B7DBEA'],
                        is3D: "false",
                        vAxis: {
                            title: ""
                        },
                        hAxis: {
                            title: ""
                        }
                    }
                };
                $scope.updateChartData = function () {
                    $scope.perMediaDeliveryChart.data = [
                        ['Label', ''],
                        ['Text', $scope.viewModel.messagesSentStats.last30DaysSmsSent],
                        ['Email', $scope.viewModel.messagesSentStats.last30DaysEmailSent],
                        ['Calls', $scope.viewModel.messagesSentStats.last30DaysVoiceSent]
                    ];
                };
            }
        };
    }]);
//# sourceMappingURL=messages-overview.directive.js.map